import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Funciona si llevo años con ansiedad o burnout?',
    a: 'Sí. El protocolo está diseñado específicamente para personas con estrés crónico acumulado. La mayoría nota cambios desde la primera semana con las técnicas de respiración.'
  }, {
    q: '¿Necesito experiencia previa en meditación o mindfulness?',
    a: 'No. Todas las técnicas parten desde cero. Las explicaciones son simples, directas y aplicables sin conocimiento previo.'
  }, {
    q: '¿Funciona para hombres y mujeres?',
    a: 'Sí. El cortisol y el burnout afectan a ambos por igual. Incluye además un capítulo especial dedicado al agotamiento materno y la carga mental femenina latina.'
  }, {
    q: '¿Cuánto tiempo debo dedicarle cada día?',
    a: 'Entre 15 y 30 minutos diarios. El protocolo está diseñado para personas con poco tiempo — sin rituales complicados ni largas sesiones de meditación.'
  }, {
    q: '¿Cómo recibo el e-book?',
    a: 'Inmediatamente después del pago recibes un email con el enlace de descarga en PDF. Sin esperas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-brand-light-sage" data-id="element-14">
      <div className="max-w-3xl mx-auto px-6" data-id="element-15">
        <FadeIn data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-forest text-center mb-12" data-id="element-17">
            Preguntas frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-19">
              <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-20">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-21">
                  <span className="font-serif font-bold text-lg text-brand-charcoal pr-4" data-id="element-22">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-forest transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-23" />
                </button>

                <AnimatePresence data-id="element-24">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-25">
                      <div className="px-6 pb-5 text-brand-gray leading-relaxed" data-id="element-26">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}